<template>
  <div>
    <swiper v-if="hasBannerList" ref="mySwiper" :class="$style.swiper" :options="swiperOption">
      <swiper-slide
        v-for="item in bannerList"
        :key="item.id"
        :class="$style['swiper-slide']"
        :style="{ backgroundImage: `url(${item.banner})` }"
      >
        <div :class="$style['banner-bottom']">
          <img :src="item.icon" alt />
          <div :class="$style['banner-info']">
            <div :class="$style['info-top']">
              <span>{{ item.title }}</span>
            </div>
            <div :class="$style['info-bottom']">{{ item.description }}</div>
          </div>
          <img :src="downloadImg" alt />
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
let vm = ''
import { CDN_URL } from "@/config/index.js";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { getGiftBannerList } from '@/api/giftCenter';
import 'swiper/css/swiper.css';
export default {
  name: 'SlideShow',
  data() {
    return {
      downloadImg: `${CDN_URL}/gameCenter/download.png`, // 点击下载小图标
      bannerList: [], // 轮播图banner数组
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 3000, // 3秒切换一次
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          click(e) {
            if (e.target.className.includes('swiper-pagination-bullet') && e.target.localName == 'span') return
            let realIndex = this.realIndex
            vm.handleLink(vm.bannerList[realIndex])
          }
        }
      },
      hasBannerList: false,
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  created() {
    vm = this
    this.getBannerList()
  },
  methods: {
    // 获取banner
    async getBannerList() {
      const r = await getGiftBannerList();
      this.bannerList = [...r.data];
      if (this.bannerList.length) {
        setTimeout(() => {
          this.hasBannerList = true
        }, 600);
      }
    },
    handleLink(item) {
      window.open(item.link, "_self");
    },
  },
}
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
// 轮播图
.swiper {
  width: 358px;
  height: 160px;
  margin: auto;
  margin-top: 17px;
  border-radius: 7px;
  box-shadow: 0px 5px 6px 0px rgba(60, 10, 10, 0.2);
  overflow: hidden;
  position: relative;
  .swiper-slide {
    list-style: none;
    float: left;
    width: 361px;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    .banner-bottom {
      width: 100%;
      height: 45px;
      background-color: rgba(0, 0, 0, 0.3);
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      padding: 0px 10px 8px 10px;
      > img:nth-child(1) {
        width: 37px;
        height: 37px;
        border-radius: 7px;
        margin-right: 7px;
        margin-top: 4px;
      }
      .banner-info {
        width: 230px;
        height: 26px;
        color: #fff;
        font-weight: 400;
        margin-top: 7px;
        .info-top {
          width: 100%;
          line-height: 13px;
          font-size: 13px;
          > img {
            width: 13px;
            height: 6px;
            transform: translate3d(3px, -4px, 0px);
          }
        }
        .info-bottom {
          @include ellipsis(1);
          width: 100%;
          font-size: 10px;
          line-height: 13px;
          margin-top: 3px;
        }
      }
      > img:nth-child(3) {
        width: 82px;
        height: 27px;
        margin-top: 5px;
      }
    }
  }
}
</style>
<style>
.swiper-pagination-bullet {
  background-color: #959595;
  opacity: 1;
  width: 6px;
  height: 6px;
}
.swiper-pagination-bullet-active {
  background-color: #ffd164;
  opacity: 1;
}
</style>
